import React, { useState, useEffect } from 'react';
import { ArrowDownRight, ArrowRightLeft, ArrowUpRight, Download, Loader } from 'lucide-react';

const Transactions = ({ userData }: { userData?: any }) => {
  const [filter, setFilter] = useState('All');
  const [transactions, setTransactions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userData && userData.id) {
      fetch(`https://motilalalgo.com/api/profile/${userData.id}/transactions`)
      // fetch(`http://localhost:10001/api/profile/${userData.id}/transactions`)
        .then(res => res.json())
        .then(data => {
          setTransactions(data);
          setLoading(false);
        })
        .catch(err => {
          console.error("Failed to fetch transactions:", err);
          setLoading(false);
        });
    }
  }, [userData]);

  // Naya logic: Data ko filter karne ke liye based on active button
  const filteredTransactions = transactions.filter(tx => {
    if (filter === 'All') return true;
    if (filter === 'Deposits') return tx.type === 'DEPOSIT';
    if (filter === 'Withdrawals') return tx.type === 'WITHDRAW';
    return true;
  });

  if (loading) {
    return <div className="h-full flex items-center justify-center text-[#3b82f6]"><Loader className="animate-spin" size={40} /></div>;
  }

  return (
    <div className="max-w-5xl mx-auto space-y-8 font-[Urbanist] pb-10">
      <div className="flex flex-col md:flex-row justify-between md:items-end gap-4">
        <div>
          <h1 className="text-3xl md:text-4xl font-black text-[#0f172a]">Transactions</h1>
          <p className="text-[#64748b] font-medium mt-1 text-sm md:text-base">View your complete account statement.</p>
        </div>
        {/* <button className="flex items-center justify-center gap-2 bg-white border border-[#f1f5f9] text-[#0f172a] px-5 py-3 rounded-[16px] text-sm font-black shadow-sm hover:shadow-md hover:border-[#bfdbfe] hover:text-[#3b82f6] transition-all">
          <Download size={18} strokeWidth={2.5} /> Download Statement
        </button> */}
      </div>

      <div className="bg-white border border-[#f1f5f9] rounded-[30px] p-6 md:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        {/* Filters - Yahan se 'Trades' hata diya gaya hai */}
        <div className="flex gap-3 mb-8 border-b border-[#f1f5f9] pb-5 overflow-x-auto custom-scrollbar">
          {['All', 'Deposits', 'Withdrawals'].map((f) => (
            <button 
              key={f} 
              onClick={() => setFilter(f)}
              className={`px-5 py-2.5 rounded-[14px] text-sm font-black whitespace-nowrap transition-all ${filter === f ? 'bg-[#0f172a] text-white shadow-md' : 'bg-[#f8fafc] border border-[#f1f5f9] text-[#64748b] hover:bg-[#f1f5f9] hover:text-[#0f172a]'}`}
            >
              {f}
            </button>
          ))}
        </div>

        {/* Transaction List */}
        <div className="space-y-4">
          {/* Yahan transactions.map ki jagah filteredTransactions.map use kiya hai */}
          {filteredTransactions.length > 0 ? (
            filteredTransactions.map((tx, idx) => (
              <div key={idx} className="flex items-center justify-between p-4 bg-[#f8fafc] border border-[#f1f5f9] rounded-[20px] hover:bg-white hover:border-[#bfdbfe] hover:shadow-sm transition-all duration-300">
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-[16px] flex items-center justify-center border shadow-sm ${tx.type === 'DEPOSIT' ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : tx.type === 'WITHDRAW' ? 'bg-red-50 text-red-600 border-red-100' : 'bg-[#eff6ff] text-[#3b82f6] border-[#bfdbfe]'}`}>
                    {tx.type === 'DEPOSIT' ? <ArrowDownRight size={24} strokeWidth={2.5} /> : <ArrowUpRight size={24} strokeWidth={2.5} />}
                  </div>
                  <div>
                    <p className="font-black text-[#0f172a] text-base">{tx.type === 'BUY' ? `Bought ${tx.asset}` : tx.type}</p>
                   <p className="text-[11px] text-[#94a3b8] font-bold uppercase tracking-wide mt-0.5"> 
  {new Date(tx.created_at).toLocaleDateString('en-IN')}
</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className={`font-black text-lg ${tx.type === 'DEPOSIT' ? 'text-emerald-600' : 'text-[#0f172a]'}`}>
                    {tx.type === 'DEPOSIT' ? '+' : '-'}₹{parseFloat(tx.amount).toFixed(2)}
                  </p>
                  <p className={`text-[10px] ... ${tx.status === 'Success' || tx.status === 'SUCCESS' ? 'text-emerald-500' : 'text-orange-500'}`}>{tx.status}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-12 text-[#94a3b8] font-bold">
              <div className="w-16 h-16 bg-[#f8fafc] rounded-full flex items-center justify-center mx-auto mb-4 border border-[#f1f5f9]">
                <ArrowRightLeft className="text-[#cbd5e1]" size={24} strokeWidth={2.5} />
              </div>
              No transactions found.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Transactions;